import moment = require("moment");
import {RestDataLoader} from "../../../../../../dashboard/widgets/unilever/RestDataLoader";
import {NewMaintenanceFormData} from "./NewMaintenanceForm";

const COFFEE_PER_CONSUMPTION: number = 7.5;

class Service {

    public addNewMaintenance(equipmentGUID: string, maintenanceData: NewMaintenanceFormData): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            RestDataLoader.postJSON(
                "equipment/" + equipmentGUID + "/maintenance",
                {
                    signalDate: maintenanceData.date.toISOString(),
                },
                resolve,
                () => {
                    reject("Error in requesting data");
                },
            );
        });
    }

    public updateMaintenance(equipmentGUID: string, maintenanceData: NewMaintenanceFormData): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            RestDataLoader.patchJSON(
                "equipment/" + equipmentGUID + "/maintenance",
                {
                    list: [
                        {
                            op: "replace",
                            path: "signalDate",
                            value: maintenanceData.date.toISOString(),
                        },
                    ],
                },
                resolve,
                () => {
                    reject("Error in requesting data");
                },
            );
        });
    }

    public deleteMaintenance(equipmentGUID: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            RestDataLoader.deleteJSON(
                "equipment/" + equipmentGUID + "/maintenance",
                {},
                resolve,
                () => {
                    reject("Error in requesting data");
                },
            );
        });
    }

    public getLastMaintenanceDate(equipmentGUID: string): Promise<Date> {
        return new Promise<any>((resolve, reject) => {
            RestDataLoader.loadData(
                "equipment/" + equipmentGUID + "/maintenance",
                null,
                resolve,
                () => reject("Error in requesting data"),
            );
        }).then((data) => {
            console.log(data);
            return new Date(data.signalDate);
        });
    }

    public getMassOfCoffeeConsumed(equipmentGUID: string, fromDate: Date, toDate: Date): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            RestDataLoader.loadData(
                "equipment/coffeeMachines/" + equipmentGUID + "/coffees/count",
                {
                    startDate: moment(fromDate).format("YYYY-MM-DDTHH:mm").toString(),
                    endDate: moment(toDate).format("YYYY-MM-DDTHH:mm").toString(),
                },
                (data: any) => {
                    let count: number = null;
                    if (data && data.count != null) {
                        count = data.count * COFFEE_PER_CONSUMPTION / 1000;
                    }
                    resolve(count);
                },
                () => {
                    reject("Errore requesting data");
                },
            );
        });
    }

    public getEquipmentInstallationDate(equipmentGUID: string): Promise<Date> {
        return new Promise<any>((resolve, reject) => {
            RestDataLoader.loadData(
                "equipment/" + equipmentGUID + "/installations/current",
                null,
                resolve,
                () => reject("Error in requesting data"),
            );
        }).then((data) => {
            const validDateText = data.installationDate.replace(/\[.*\]/, "");
            return new Date(validDateText);
        });
    }
}

export const MaintenanceService = new Service();
